/*=============================================== CardImage ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { css } from "styled-components";
import Variables from "./Variables";
import { H5 } from "./Font";
import Mixins from "./Mixins";
import CardContainer from "./CardContainer";
import Image from "./Image";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
/*==================== Component ====================*/
var CardImage = function (_a) {
    var title = _a.title, src = _a.src, alt = _a.alt, to = _a.to, icon = _a.icon, fajnyIcon = _a.fajnyIcon, props = __rest(_a, ["title", "src", "alt", "to", "icon", "fajnyIcon"]);
    return (React.createElement(Container, __assign({ to: to ? to : undefined }, props),
        React.createElement(Img, { src: src, alt: alt, width: "100%", height: "100%", fit: "cover" }),
        icon && React.createElement(StyledIcon, { src: icon, size: 48 }),
        fajnyIcon && React.createElement(StyledFajnyIcon, { name: fajnyIcon, size: 48 }),
        React.createElement(Title, null, title)));
};
export default CardImage;
/*==================== Styles ====================*/
var Img = styled(Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n"])));
var Title = styled(H5)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    width: 100%;\n    height: 100%;\n    ", ";\n    padding: ", ";\n    aspect-ratio: 16/9;\n"], ["\n    color: ", ";\n    width: 100%;\n    height: 100%;\n    ", ";\n    padding: ", ";\n    aspect-ratio: 16/9;\n"])), Variables.Colors.White, Mixins.Flexbox({
    $align: "flex-start",
    $justify: "flex-end",
    $direction: "column",
}), Variables.Spacers.S);
var IconStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 2;\n    color: ", ";\n    top: calc(50% - 48px / 2);\n    left: calc(50% - 48px / 2);\n"], ["\n    position: absolute;\n    z-index: 2;\n    color: ", ";\n    top: calc(50% - 48px / 2);\n    left: calc(50% - 48px / 2);\n"])), Variables.Colors.White);
var StyledIcon = styled(Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), IconStyles);
var StyledFajnyIcon = styled(FajnyIcon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), IconStyles);
var Container = styled(CardContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: relative;\n    aspect-ratio: 16/9;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        background-color: ", ";\n    }\n\n    ", " {\n        z-index: 0;\n    }\n\n    ", " {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 3;\n    }\n"], ["\n    position: relative;\n    aspect-ratio: 16/9;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        background-color: ", ";\n    }\n\n    ", " {\n        z-index: 0;\n    }\n\n    ", " {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 3;\n    }\n"])), Variables.Overlays.Plain.Black50, Img, Title);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
